<script>
	import { Router, Link, link, Route } from "svelte-routing";

	const promotions = [
		{
			key: 'ANY',
			title: 'Black freire',
			image: 'seloBlack2024.png',
			link: '/black-freire#cidade=Porto%20Alegre&valor_de=0&valor_ate=0&valor_completo=0'
		}
	];

	export let realty = null;
	let promotion = null;
	if (realty != null && realty.Promotion != null && realty.Promotion.length > 0) {
		promotion = promotions.find(p => p.key.toUpperCase() == realty.Promotion.toUpperCase());

		//Se começar com número, usa a promo MES
		if (promotion == null) {
			promotion = promotions.find(p => p.key == 'ANY');
			promotion.link += '&tipo_negociacao=1';
		}
	}

	if (realty != null && realty.ImovelEmCampanha != null && realty.ImovelEmCampanha && realty.ReferenceId.startsWith('FR')) {
		promotion = promotions.find(p => p.key == 'ANY');
		promotion.link += '&tipo_negociacao=-2';
	}
</script>

{#if promotion != null}
<div class="selos">
	{#if promotion.link != null}
	<a class="selo" href="{promotion.link}" use:link replace target="_self">
		<img src="/assets/images/selos/{promotion.image}" border="0" alt={promotion.title} />
	</a>
	{:else}
		<img class="selo" src="/assets/images/selos/{promotion.image}" border="0" alt={promotion.title} style="display: none;" />
	{/if}
</div>
{:else}
{/if}

<style type="text/sass">

.selos
	position: absolute
	top: 48px
	left: 10px
	img
		max-width: 101px
		object-fit: contain
</style>